import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionButtonDropdown from "../../../Components/ActionButtonDropdown"
import Pagination from "../../../Core/Pagination/Pagination";
import ListLayout from "../../../Core/Layout/ListLayout";
import Table from "../../../Core/Table/Table";
import Tabs from "../../../Components/Tabs";
import { useGetWorkOrderListQuery } from "../../../store/api/assemblyapi";
import { useGetDoctypeCountQuery } from "../../../store/api/globalapi";
import ExportCSV from '../../../Core/Export/ExportCSV'
import ListFilters from '../../../Core/ListFilters/ListFilters'
import ConfigureColumnsNew from "../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import { useDeleteDocMutation } from '../../../store/api/globalapi'
import DelConfirmPopup from "../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../utils/useScreenHeight";


const MainContent = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScale, pageSize } = useScreenHeight();
    const [filters, setFilters] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [purchaseData, setPurchaseData] = useState([]);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showFilters, setShowFilters] = useState(false)
    // States used for deleting the records
    const [deleteDoc] = useDeleteDocMutation();
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false)
    const [delDone, setDelDone] = useState(false)

    const { data: workorderList, isLoading } = useGetWorkOrderListQuery({ page: pageSize * (currentPage - 1), pageSize });
    const { data: number_of_count } = useGetDoctypeCountQuery('Work Order');

    const [showExportPopup, setShowExportPopup] = useState(false);

    const filtersConfig = [
        { name: "siNo", label: "S. No.", width: '10%', type: 'number' },
        { name: 'production_item', label: 'Item To Manufacture', width: '20%', type: 'text' },
        { name: 'name', label: 'ID', width: '20%', type: 'text' },
        {
            name: 'creation',
            label: 'Date',
            type: 'date',
            width: '20%',
            dateFormat: 'yyyy-MM-dd'
        },
        {
            name: 'status',
            label: 'Status',
            width: '20%',
            type: 'select',
            options: [
                { value: 'Draft', label: 'Draft' },
                { value: 'Not Started', label: 'Not Started' },
                { value: 'In Process', label: 'In Process' },
                { value: 'Completed', label: 'Completed' },
                { value: 'Cancelled', label: 'Cancelled' },
            ]
        },

    ];

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        setCurrentPage(1);
    };
    const handleView = (id) => {
        try {
            navigate(`/assmbly/view-work-order`, { state: { assemblyID: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };
    const handleEdit = async (id) => {
        // navigate(`/inbound/purchaseorder/edit-purchase-order/`, { state: { PurchaseId: id } });
    };
    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true)
        setAlreadySubmitData(false)
        setDelmessage("Are you sure you want to Delete this Work Order?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    }

    const delHandleConfirm = async () => {
        
        try {
            await deleteDoc({ doctype: "Work Order", name: delSelectedId }).unwrap()
            setDelmessage(`Work Order ${delSelectedId} deleted successfully!`)
            setDelDone(true)
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelSelectedId(null);
                setDelDone(false)
                getData();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Work Order!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };

    const [columnsConfig, setColumnsConfig] = useState([]);
    useEffect(() => {
			setColumnsConfig([
				{
					header: "S. No.",
					name: "S. No.",
					accessor: "siNo",
					width: "7%",
					cellRenderer: (row, rowIndex) =>
						rowIndex + 1 + pageSize * (currentPage - 1),
					sortable: false,
					visible: true,
				},
				{
					header: "Item To Manufacture",
					name: "Item To Manufacture",
					accessor: "production_item",
					width: "20%",
					visible: true,
					sortable: true,
				},
				{
					header: "Id",
					name: "Id",
					accessor: "name",
					width: "20%",
					visible: true,
					sortable: false,
				},
				{
					header: "Date",
					name: "Date",
					accessor: "creation",
					width: "20%",
					visible: true,
					sortable: true,
					cellRenderer: (row) => new Date(row.creation).toLocaleDateString(),
				},
				{
					header: "Status",
					name: "Status",
					accessor: "status",
					width: "20%",
					sortable: false,
					visible: true,
					cellRenderer: (row) => {
						const status = row.status;
						let color;

						switch (status) {
							case "Completed":
								color = "#65A30D";
								break;
							case "Draft":
								color = "#FF5969";
								break;
							case "In Process":
								color = "#F97316";
								break;
							case "Not Started":
								color = "#FF5969";
								break;
							default:
								color = "#000000";
						}

						return <span style={{ color }}>{status}</span>;
					},
				},
				{
					header: "Action",
					name: "Action",
					width: "13%",
					accessor: "action",
					sortable: false,
					visible: true,
					cellRenderer: (row) => (
						<ActionButtonDropdown
							id={row.name}
							onView={() => handleView(row.name)}
							onEdit={() => handleEdit(row.name)}
							onDelete={() => handleDelete(row.name)}
							actions={["view", "delete"]}
						/>
					),
				},
			]);
		}, [currentPage]);
     // Handle column configuration changes
    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);

    const actionButtons = [
    {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/assmbly/create-assembly",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add Work Order"
        }
    ];

    const getData = () => {
        console.log("WO Data",workorderList)
        setPurchaseData(workorderList.data)
    };
    useEffect(() => {
        if (pageSize > 0 && !isLoading) {
            getData();
        }
    }, [currentPage, filters, workorderList, isLoading,screenHeight, screenScale, pageSize]);
    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
			<div
				className="container-fluid d-flex flex-column"
				style={{ flexGrow: "1" }}
			>
				<Tabs />
				<ListLayout
					breadcrumbItems={[
						{ label: "Work Order" },
						{ label: "Work Order List", style: { color: "#391F84" } },
					]}
					actionButtons={actionButtons}
				>
					{showFilters && (
						<ListFilters
							filtersConfig={filtersConfig}
							onFilterChange={handleFilterChange}
							currentFilters={filters}
							setShowFilters={setShowFilters}
						/>
					)}

                {showColumnConfig &&
                    <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Work Order"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo", "action", "creation", "production_item", "name"]}
                    />}
                <Table
                    columns={visibleColumns}
                    data={purchaseData}
                    loading={isLoading}
                />
                {delPopupVisible &&
                    <DelConfirmPopup
                        alredysubmitdata={alreadySubmitData}
                        delSelectedId={delSelectedId}
                        visible={delPopupVisible}
                        message={delmessage}
                        onConfirm={delHandleConfirm}
                        onCancel={delHandleCancel}
                        delDone={delDone}
                    />
                }
                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={number_of_count?.message}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />

            {showExportPopup && (
                <ExportCSV
                    doctype="Work Order"
                    fieldsData={accessors}
                    onClose={() => setShowExportPopup(false)}
                />
            )}
            </ListLayout>
        </div>
    );
};

export default MainContent;